import { render, staticRenderFns } from "./CausaliDocumentoEdit.vue?vue&type=template&id=4a1635a6"
import script from "./CausaliDocumentoEdit.vue?vue&type=script&lang=js"
export * from "./CausaliDocumentoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports